import React from 'react';
import HighlightContext from './context';
import { Highlight  as HighlightPlugin } from "react-highlighter-ts";

const wrapWithHighlight = (children,keyword) =>{
    return React.Children.map(children, (child) => {
                if (!child) return child;

                //text node
                if (child && !child.props) {
                    return <HighlightPlugin search={keyword}>{child}</HighlightPlugin>;
                }

                if (child && child.props.children) {
                    return React.cloneElement(child, {
                        children: wrapWithHighlight(child.props.children,keyword),
                    })
                }

                return React.cloneElement(child);
            })
}

const Highlight = function({children}) {
    return (
        <HighlightContext.Consumer>
                {({ keyword }) => wrapWithHighlight(children,keyword)}
        </HighlightContext.Consumer>
    )
}

export default Highlight;